var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import Cookies from 'js-cookie';
import { z } from 'zod';
import CompanyStore from 'stores/CompanyStore/store';
/**
 * Coach presence ping (SCO-469, escalation ADR §4 amendment item 5). POSTs to
 * the Node route `POST /api/v1/coach/presence`, which refreshes the
 * `presence:coach:{id}` Redis key the morning-checkin trigger reads to skip
 * the push for coaches already looking at the app. Same axios + `sbbsession`
 * pattern as {@link nudgeProducer}. Best-effort: never throws — a failed ping
 * just means presence ages out and the push fires (the safe direction).
 *
 * Resolves to the server-echoed TTL in seconds (callers derive their ping
 * cadence from it), or null on any failure.
 */
var PresencePingResponseSchema = z.object({
    success: z.literal(true),
    ttl_seconds: z.number().positive()
});
/**
 * Hard request deadline (Codex round 1, #408 P1): a proxy-held ping that
 * lands minutes later would assert presence for a coach who left — the
 * prohibited overcounting direction. Better a dropped ping (push fires,
 * status-quo) than a stale one.
 */
export var PRESENCE_PING_TIMEOUT_MS = 10 * 1000;
var pingCoachPresence = function (signal) { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, result, parsed, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiEndpoint = CompanyStore.getApiEndpoint();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("".concat(apiEndpoint, "/api/v1/coach/presence"), null, {
                        headers: { sbbsession: Cookies.get('sbb_sess') },
                        timeout: PRESENCE_PING_TIMEOUT_MS,
                        signal: signal
                    })];
            case 2:
                result = _a.sent();
                parsed = PresencePingResponseSchema.safeParse(result === null || result === void 0 ? void 0 : result.data);
                return [2 /*return*/, parsed.success ? parsed.data.ttl_seconds : null];
            case 3:
                error_1 = _a.sent();
                if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                    console.warn('Coach presence ping failed', error_1);
                }
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
export default pingCoachPresence;
